import React from 'react'

function About() {
  return (
    <div className="about-section">
      <div className="input-section">
    <h3>About</h3>
    <p className='about-content'>I am a frontend developer with a particular interest in making things simple and automating daily tasks. I try to keep up with security and best practices, and am always looking for new things to learn.</p>
    </div>
    </div>
  )
}

export default About